export interface LocalFile {
  base64data: string | ArrayBuffer | null;
  name: string;
  type: string;
}

const fileToBlob = async (blob: File): Promise<LocalFile> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () =>
      resolve({
        base64data: reader.result,
        name: blob.name,
        type: blob.type,
      });
    reader.readAsDataURL(blob);
  });
};

export const toBase64data = async (files: File[]) => {
  let finalFiles: Promise<LocalFile>[] = files?.map((file: File) => {
    return fileToBlob(file);
  });
  return Promise.all(finalFiles);
};

export const fromBase64data = async (files: LocalFile[]) => {
  let finalFiles: Promise<File>[] = files.map(async (file: any) => {
    const blob = await fetch(file.base64data).then((it) => it.blob());
    const updateFile = new File([blob], file.name, {
      type: file.type,
      lastModified: Date.now(),
    });
    return updateFile;
  });
  return Promise.all(finalFiles);
};
